import {connect} from 'react-redux';
import React, {Component} from 'react';

import ResultSearch from '../ResultSearch';
import Map from '../../../components/Base/Map';
import * as SearchConst from '../../../constants/Search';
import FiltersBlockVertical from './FiltersBlockVertical';
import FiltersBlockHorizontal from './FiltersBlockHorizontal';

class LeftBoxContentRental extends Component {
    state = {
        maxScrollTop: 0
    };

    handleScroll = event => {
        const scrollTop = event.target.scrollTop;

        if (scrollTop < this.state.maxScrollTop) {
            let documentScrollTop = document.documentElement.scrollTop;
            if (documentScrollTop !== 0) {
                const delta = this.state.maxScrollTop - scrollTop;
                const newDocumentScrollTop = documentScrollTop - delta;
                if (newDocumentScrollTop < 0) {
                    document.documentElement.scrollTop = 0;
                } else {
                    document.documentElement.scrollTop = newDocumentScrollTop;
                }
            }
        }

        this.setState({
            maxScrollTop: scrollTop
        });
    };

    getSearchLink = () => {
        const {dateStart, dateEnd} = this.props;
        let response = '?';

        if (dateStart !== undefined) {
            response += `${SearchConst.REQUEST_PARAMS_NAMES.DATE_START}=${dateStart}&`;
        }
        if (dateEnd !== undefined) {
            response += `${SearchConst.REQUEST_PARAMS_NAMES.DATE_END}=${dateEnd}`;
        }
        return response;
    };

    render() {
        const {isHorizontalMode} = this.props;

        return (
            <div className="left_box_content" onScroll={this.handleScroll}>
                <FiltersBlockVertical />
                <FiltersBlockHorizontal />

                {this.props.configuration.isGoogleApiInit && this.props.defaultLat && isHorizontalMode && <Map
                    zoom={10}
                    id="map_from_content"
                    className="map_from_content"
                    searchLink={this.getSearchLink()}
                    objects={this.props.searchPage.searchResult.rows}
                    centerLng={this.props.searchPage.requestParams.centerLng}
                    centerLat={this.props.searchPage.requestParams.centerLat}
                />}

                <ResultSearch />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    searchPage: state.searchPage,
    configuration: state.configuration,
    defaultLat: state.configuration.main.defaultLat,
    dateEnd: state.searchPage.requestParams.dateEnd,
    dateStart: state.searchPage.requestParams.dateStart,
    isHorizontalMode: state.searchPage.isHorizontalMode
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LeftBoxContentRental);


// WEBPACK FOOTER //
// ./src/components/Search/Rental/LeftBoxContentRental.js